export const messagesState = {
  loading: false,
  response: null,
  error: false,
};
